import { DIALOG_SIZE, ID } from "@libs/interfaces/layouts"
import FieldInput from "@libs/scalars"
import { SCALAR_TYPES, VerticalType } from "@libs/scalars/interface/IScalarForm"
import ConfirmButton from "@libs/useful/ConfirmButton"
import { __ } from "@libs/utilities"
import { ICategory } from "@/modules/pe-fest-module/data/interfaces"
import { useFestExport } from "@/modules/pe-fest-module/data/store"
import { useState } from "react"

/* Protopia Ecosystem component */
export interface ICriteryCategoryBtnProps { 
    category: ICategory
    onChoose: (item: ICategory) => void
}
const CriteryCategoryBtn = ({onChoose,  category}: ICriteryCategoryBtnProps): JSX.Element => { 
    const allCategories: ICategory[]   = useFestExport((state: any) => state.categories) || [] 

    const [value, setValue] = useState<ICategory>( category )
    
    const onValue = (value: ID ) => {
        console.log( value )
        setValue(allCategories.filter(m => m.id === value)[0])
    }
    return <div className='pe-critery-category-btn-container'>
        <ConfirmButton
            buttonLabel={
                <div className="flex-centered hint hint--top" data-hint={__("Category")}>
                    <div className="d-flex d-md-none pe-fest-resource-icon color-force-contrast" style={{backgroundImage:`url(/assets/img/fest/critery-icon.svg)`}} /> 
                    {
                        value?.title ? value.title : "---"
                    }
                </div>
            }
            buttonMinimal
            dialogClasssName={DIALOG_SIZE.MINIMAL}
            onConfirm={() => onChoose( value ) }
        >
            <div className="p-4">
                <FieldInput
                    editable
                    value={value}
                    vertical={VerticalType.VERTICAL}
                    onChange={onValue}
                    type={SCALAR_TYPES.TAGS} 
                    values={ allCategories.map(m => ({...m, _id: m.ID })) }
                />
            </div>
        </ConfirmButton>
    </div>
}
export default CriteryCategoryBtn